import {gsap, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
import AppearOnScroll from "./AppearOnScroll";

export default class TextAppear {
	static async init() {

		// On fait le split texte une fois chargé pour éviter les effets de bords / warning gsap
		await document.fonts.ready;

		const items = document.querySelectorAll("[data-text-appear], .title-level-0, .title-level-0-alt, .title-level-1:not(.no-appear), .title-level-2, .title-level-3, .campaign-customer-name, .campaign-name");
		this.splitTexts= [];

		items.forEach(elem => {
			const innerSplit = new SplitText(elem, {
				type: "words, lines",
				linesClass: "line"
			});

			innerSplit.lines.forEach(line => {
				if(line.querySelector(".yellow-box")){
					line.classList.remove("line");
					line.classList.add("not-animated-line");
				}
			});

			this.splitTexts.push(innerSplit);

			const delay = elem.dataset.textAppearDelay ?? 0; // Utilisez l'attribut HTML `data-aos-delay`

			const splitTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: elem,
					start: "top 90%",
				},
			});

			splitTimeline.set(elem, {
				visibility: 'visible'
			});

			splitTimeline.from(innerSplit.words, {
				delay: parseFloat(delay),
				duration: 1,
				yPercent: 150,
				ease: "power1.ease",
				stagger: 0.1,
			});
		});

		GlobalVariables.resizeCallbacks.push(this);

		AppearOnScroll.init();
	}

	static resize() {
		this.splitTexts.forEach(item => {
			item.revert();
		});
	}
}
